import { useEffect, useState } from 'react';
import { listAvatars } from '../api';
import { useClientId } from '../hooks/useClient';
import AvatarCard from '../components/AvatarCard';
import type { Avatar } from '../types/db';

export default function Avatars() {
  const clientId = useClientId();
  const [avatars, setAvatars] = useState<Avatar[]>([]);
  const [defaultId, setDefaultId] = useState<string>('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listAvatars(clientId)
      .then((a) => {
        setAvatars(a);
        if (a[0]) setDefaultId(a[0].id);
      })
      .finally(() => setLoading(false));
  }, [clientId]);

  const handleSetDefault = (id: string) => {
    setDefaultId(id);
    console.log('Imposta avatar default:', id);
  };

  return (
    <div className="mx-auto max-w-4xl space-y-6">
      <div>
        <h1 className="text-xl font-bold text-slate-900">Avatar</h1>
        <p className="mt-1 text-sm text-slate-500">
          Seleziona l'avatar per i tuoi vodcast. Gli avatar della libreria
          VoiceKit sono disponibili per tutti i clienti.
        </p>
      </div>

      {loading ? (
        <p className="text-sm text-slate-500">Caricamento…</p>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {avatars.map((avatar) => (
            <div key={avatar.id} className="flex flex-col">
              <AvatarCard
                avatar={avatar}
                isSelected={defaultId === avatar.id}
              />
              <button
                onClick={() => handleSetDefault(avatar.id)}
                className={`mt-2 w-full rounded-lg px-3 py-2 text-sm font-medium transition ${
                  defaultId === avatar.id
                    ? 'bg-brand-50 text-brand-700'
                    : 'border border-slate-300 bg-white text-slate-700 hover:bg-slate-50'
                }`}
              >
                {defaultId === avatar.id
                  ? 'Avatar predefinito'
                  : 'Imposta come default'}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
